import apiClient from '../utils/apiClient';
import { apiUtils } from '../utils/commonUtils';

/**
 * Clone tenant data from tenant 1 to new tenant
 * Calls: SELECT clone_tenant_data(1, tenantId, roleId)
 */
export const cloneTenantData = async (tenantId) => {
  try {
    const response = await apiClient.post(`/tenants/${tenantId}/clone-data`);

    if (response.data.status === 'success') {
      return {
        success: true,
        data: response.data.data,
        message: response.data.message || 'Tenant data cloned successfully',
      };
    } else {
      throw new Error(response.data.message || 'Failed to clone tenant data');
    }
  } catch (error) {
    return apiUtils.handleError(error, 'Failed to clone tenant data');
  }
};

/**
 * Get all roles for a tenant
 */
export const fetchTenantRoles = async (tenantId) => {
  try {
    const response = await apiClient.get(`/tenants/${tenantId}/roles`);

    if (response.data.status === 'success') {
      return {
        success: true,
        data: response.data.data,
        message: response.data.message,
      };
    } else {
      throw new Error(response.data.message || 'Failed to fetch roles');
    }
  } catch (error) {
    return apiUtils.handleError(error, 'Failed to fetch tenant roles');
  }
};

/**
 * Get all available menus
 */
export const fetchMenus = async (tenantId = null) => {
  try {
    const params = {};
    if (tenantId) params.tenant_id = tenantId;
    const response = await apiClient.get('/menus', { params });

    if (response.data.status === 'success') {
      return {
        success: true,
        data: response.data.data,
        message: response.data.message,
      };
    } else {
      throw new Error(response.data.message || 'Failed to fetch menus');
    }
  } catch (error) {
    return apiUtils.handleError(error, 'Failed to fetch menus');
  }
};

/**
 * Get menu IDs assigned to a role for a tenant
 */
export const fetchRoleMenus = async (tenantId, roleId) => {
  try {
    const response = await apiClient.get(`/tenants/${tenantId}/roles/${roleId}/menus`);

    if (response.data.status === 'success') {
      return {
        success: true,
        data: response.data.data,
        message: response.data.message,
      };
    } else {
      throw new Error(response.data.message || 'Failed to fetch role menus');
    }
  } catch (error) {
    return apiUtils.handleError(error, 'Failed to fetch role menus');
  }
};

/**
 * Update (sync) menus for a role in a tenant
 */
export const updateRoleMenus = async (tenantId, roleId, menuIds) => {
  try {
    const response = await apiClient.put(
      `/tenants/${tenantId}/roles/${roleId}/menus`,
      { menu_ids: menuIds }
    );

    if (response.data.status === 'success') {
      return {
        success: true,
        message: response.data.message || 'Role menus updated successfully',
      };
    } else {
      throw new Error(response.data.message || 'Failed to update role menus');
    }
  } catch (error) {
    return apiUtils.handleError(error, 'Failed to update role menus');
  }
};
